import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { selectRouteParams } from 'selectors/general';
import { selectInstructor, selectIsInstructorLoading } from '../Instructors.selectors';
import { deleteInstructor as deleteInstructorAction } from '../Instructors.saga';
import InstructorEditForm from './InstructorEditForm';

const prepareInitialValues = (values = {}) => {
  const { socialHandles, ...restValues } = values;

  if (_isEmpty(socialHandles)) {
    return { socialHandles: [{ service: 'instagram', userName: '' }], ...restValues };
  }

  return values;
};

export function mapStateToProps(state) {
  const { id: instructorId } = selectRouteParams(state);
  const instructor = selectInstructor(state, instructorId);
  const { id } = instructor || {};

  return {
    instructor: prepareInitialValues(instructor),
    isInstructorLoading: selectIsInstructorLoading(state, instructorId),
    showDeleteButton: !!id,
    id,
  };
}

const mapDispatchToProps = {
  deleteInstructor: deleteInstructorAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { id, ...restStateProps } = stateProps;
  const { deleteInstructor, ...restDispatchProps } = dispatchProps;
  return {
    ...restStateProps,
    ...restDispatchProps,
    handleDelete: deleteInstructor.bind(null, id),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(InstructorEditForm);
